export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20composition%20with%20soft%20coral%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%20reminiscent%20of%20comic%20panel%20layouts%2C%20gentle%20overlapping%20geometric%20forms%2C%20minimalist%20elegant%20style%2C%20warm%20ambient%20lighting%2C%20no%20text%2C%20clean%20smooth%20textures%2C%20digital%20art%20aesthetic&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="禁漫天堂背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-accent-500/90 text-background-50 rounded-full text-xs font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            2026年最新入口持续更新中
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            禁漫天堂
            <span className="block text-accent-300 text-xl md:text-2xl lg:text-3xl font-medium mt-2">
              官方入口与完整使用指南
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-xl mx-auto mb-10 leading-relaxed">
            为您提供禁漫天堂最新访问入口、注册登录教程、内容分类导览及常见问题解答，
            帮助您快速、安全地找到并使用禁漫天堂的全部功能。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-rocket-line mr-2"></i>
              立即进入平台
            </a>
            <a
              href="#categories-overview"
              className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-50/30 text-background-50 rounded-lg text-base font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line mr-2"></i>
              浏览内容分类
            </a>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10 text-background-200/70 text-sm">
            <div className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-accent-300"></i>
              <span>安全访问</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-flashlight-line text-accent-300"></i>
              <span>极速加载</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-device-line text-accent-300"></i>
              <span>多端支持</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}